import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SBGArrayModel, SBGModel } from "../../models/SBGModel";

const initialSBGState: SBGArrayModel = {
  all_SBGs: [],
  particular_SBG: {
    sbgid: 0,
    name: "",
    description: "",
    sbguserId: 0,
    isActive: false,
  },
  isSbgsFetching: false,
};

const sbgSlice = createSlice({
  name: "SBG",
  initialState: initialSBGState,
  reducers: {
    setSBGs(state, action: PayloadAction<SBGModel[]>) {
      state.all_SBGs = action.payload;
    },
    setParticularSBG(state, action: PayloadAction<SBGModel>) {
      state.particular_SBG = action.payload;
    },
    setIsSbgsFetching(state, action: PayloadAction<boolean>) {
      state.isSbgsFetching = action.payload;
    },
  },
});

export default sbgSlice;
